module.exports = __webpack_public_path__ + "img/coupe.1bf7875d.webp";